(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const countBlocksArr = document.querySelectorAll('.trusler-block--countup');

		$(countBlocksArr).each( function( index, value ) {

			const counterId 				= $(this).find('.counter__number').attr('id'),
				  counterTarget 			= $(this).find('.counter__number').attr('data-ctarget'),
				  startVal 					= $(this).find('.count-this-up').attr('data-counter-start'),
				  endVal 					= $(this).find('.count-this-up').attr('data-counter-end'),				  
				  counterOptsObj 			= {
					enableScrollSpy: 	true,
					scrollSpyOnce: 		true,
					scrollSpyDelay: 	0,					
					useEasing: 			true,
					duration: 			5,
					startVal: 			startVal,
					endVal: 			endVal,					
				  };

			  window['counter' + index] = new CountUp( 
				counterId, 
				counterTarget, 
				counterOptsObj 
		  	  );			  	  				

		});

		countBlocksArr.forEach(block => {
		  
			ParcelFunctions.inViewport(block, 0.3, 0.15, 'block-in-viewport');

		});			

	});

})(jQuery);